export default "/images/vendor/flag-icon-css/flags/1x1/bl.svg?66cdc56cf5c323535418b01b09e1384a";